module.exports = __webpack_public_path__ + "img/kan.7f4f0312.png";